import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';

import Button from "components/CustomButtons/Button.js";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Table from "components/Table/Table.js";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import CSVReader from "react-csv-reader";
import SomeSpinner from "components/Somespinner/Somespinner.js"

import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import DatePicker from "components/Datepicker/Datepicker";
import api from "assets/services/api";
import moment from 'moment';

const useStyles2 = makeStyles(styles2);

const styles = {
    margintp: {
        textAlign: "right",
        marginTop: "10px"
    }
};

const useStyles = makeStyles(styles);

function ModalAddOrderSellsman(props) {


    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    const classes2 = useStyles2();
    const classes = useStyles();
    const [br, setBR] = React.useState(false);

    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [clients, setClients] = useState([]);
    const [list, setList] = useState([]);

    const [productId, setProductId] = useState(0);
    const [clientId, setClientId] = useState(null);
    const [price, setPrice] = useState();
    const [amount, setAmount] = useState();
    const [discount, setDiscount] = useState("");
    const [startDate, setStartDate] = useState(new Date().withoutTime());
    const [payment, setPayment] = useState("A VISTA");
    const [nature, setNature] = useState("VENDA");
    const [observation, setObservation] = useState("")
    const [payments, setPayments] = useState([{ id: 0, description: "" }])
    const [tabulation, setTabulation] = useState([])

    const [totalList, setTotalList] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [resultOperation, setResultOperation] = useState(0);
    const [listProducts, setListProducts] = useState([]);
    const [controlSnack, setControlSnack] = useState(false);
    const parse_natures = {
        VENDA: 'sell',
        BONIFICAÇÃO: 'bonification',
        AMOSTRA: 'sample'
    };
    const natures = [
        "VENDA",
        "BONIFICAÇÃO",
        "AMOSTRA"
    ];
    const { storageId, user } = useAuth();
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        loadProducts();
        loadPayments();
    }, []);

    useEffect(() => {
        if (controlSnack) showNotification("br");
    }, [controlSnack]);

    useEffect(() => {
        setList(listProducts);
        calcTotal();
    }, [listProducts, totalList])


    useEffect(() => {
        loadClients();
        if (clientId != null) {
            paymentClient();
            loadTabulation();
        }
    }, [clientId])

    useEffect(() => {
        for (let i = 0; i < tabulation.length; i++) {
            if (productId === `${tabulation[i].id_product}`) {
                setPrice(tabulation[i].price_of_product);
                break
            } else {
                setPrice(0);
            }
        }
    }, [productId, clientId])



    const paymentClient = async () => {
        for (let i = 0; i < clients.length; i++) {
            if (clientId == clients[i].id) {
                if (clients[i].preference) {
                    setPayments([{ id: 0, description: clients[i].preference }, ...payments])
                    setPayment(clients[i].preference)
                }
                break
            }

        }
    }

    const loadPayments = async () => {
        const responsePayment = await api.get('/payment')
        setPayments(responsePayment.data)
    }

    async function addToList(e) {
        e.preventDefault();
        let order;

        if (amount === undefined || amount <= 0) {
            return alert('Quantidade inválida');
        }

        if (!clientId) {
            return alert('Selecione o cliente');
        }

        if (price === 0) {
            return alert('Informe o valor');
        }

        let totalProduct = amount * price
        const verify_prod = list.filter(p => p.id_product == productId);
        if (verify_prod.length > 0) {
            return alert('Produto já adicionado');
        };
        let theProduct = products.filter(p => p.id == productId);
        console.log(products)
        const id_product = theProduct[0].id

        if (price < Number(theProduct[0].standart_price_more_5)) {
            return alert(`Valor menor que o minimo permitido R$ ${theProduct[0].standart_price_more_5}`);
        };
        if (price < Number(theProduct[0].lower_middle) || price > Number(theProduct[0].upper_middle)) {
            alert(`Valor fora da media de vendas da operação`);
        };

        let box
        for (let i = 0; i < products.length; i++) {
            if (products[i].id === id_product) {
                box = products[i].box
                break
            }
        }

        const totalBox = parseFloat(amount / box).toFixed(2);

        let client
        const id_client = clientId ? clientId : clients[0].id;
        for (let i = 0; i < clients.length; i++) {
            if (parseInt(clients[i].id) === parseInt(id_client)) {
                client = clients[i].social_reason
                break
            }
        }


        const controller = await await api.get(`/order_controller/${storageId}`)
        const order_controller = controller.data

        let nature_operation
        if (nature === "VENDA") {
            nature_operation = "sell"
        } else if (nature === "BONIFICAÇÃO") {
            nature_operation = "bonification"
        } else if (nature === "AMOSTRA") {
            nature_operation = "sample"
        }

        order = {
            totalProduct,
            nature_operation,
            order_controller,
            name: theProduct[0].name,
            amount,
            sellsman: user.name,
            price,
            client,
            startDate,
            totalBox,
            id_client,
            sellsman2: storageId,
            id_product
        };
        setListProducts(prevOrder => ([...prevOrder, order]));
    }
    async function calcTotal() {
        let total = 0;
        let discount = 0;
        if (listProducts) {
            for (let i = 0; i < listProducts.length; i++) {
                total = parseFloat(total) + ((parseFloat(listProducts[i].amount)) * (parseFloat(listProducts[i].price)));
                discount = parseFloat(listProducts[i].discount ? listProducts[i].discount : 0);
            }
        }
        setTotalDiscount(parseFloat(discount).toFixed(2));
        setTotalList(parseFloat(total).toFixed(2));
    }
    async function deleteToList(index) {
        let listNew = [...listProducts];
        listNew.splice(index, 1);
        setListProducts(listNew);
    }
    async function cleanList() {
        let listNew = [];
        setListProducts(listNew);
    }
    async function loadProducts() {
        const response = await api.get(`/product/admin/new/order/${storageId}/${moment().subtract(90, "days").format('YYYY-MM-DD')}/${moment().format('YYYY-MM-DD')}?type=sellsman`);
        setProducts(response.data);
        setProductId(response.data[0].id)
    }
    async function loadClients() {
        const response = await api.get(`/app/client/for/sellsman/${storageId}?search=`);
        setClients(response.data);
    }
    async function loadTabulation() {
        const response = await api.get(`/tabulation/client/${clientId}`);
        setTabulation(response.data);
        if (response.data.length > 0) {
            if (response.data[0].id_product === products[0].id) {
                setPrice(response.data[0].price_of_product)
            }
        }
    }
    async function addOrder(e) {
        e.preventDefault();
        console.log(parse_natures[nature], observation)
        if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                const save = await api.post('/order', {
                    amount: list[i].amount,
                    price_of_product: list[i].price,
                    box: list[i].totalBox,
                    id_admin: user.id_admin,
                    id_sellsman: parseInt(list[i].sellsman2),
                    id_client: parseInt(list[i].id_client),
                    id_product: parseInt(list[i].id_product),
                    order_controller: parseInt(list[i].order_controller),
                    discount: discount,
                    nature_operation: parse_natures[nature],
                    payment_method: payment,
                    observation,
                    price_total: list[0].totalProduct,
                    date_of_delivery: list[0].startDate
                })
                setLoading(false);
                setControlSnack(true);
                setControlSnack(false);
            }
            setListProducts([]);
            setClientId(null);
            setObservation("");
            setPayment("A VISTA");
            setPrice(0);
            setAmount();

            props.LoadOrders();
            props.onHide();
        }
    }

    const tableData = () => {
        let teste = [];

        for (let i = 0; i < list.length; i++) {
            teste[i] = [];
            teste[i].push(list[i].amount);
            teste[i].push(list[i].name);
            teste[i].push(list[i].price);
            teste[i].push(list[i].discount);
            teste[i].push(list[i].sellsman);
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip
                        id="tooltip-top-start" title="Deletar" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Close" className={classes2.tableActionButton} onClick={() => deleteToList(i)} >
                            <Close className={classes2.tableActionButtonIcon + " " + classes2.close} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }
        return teste;
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar Pedido
                </Modal.Title>
            </Modal.Header>
            <Form >
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridClients">
                            <Form.Label>Cliente</Form.Label>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={clients}
                                getOptionKey={(client) => client.id}
                                getOptionLabel={(clients) => `${clients.social_reason} - ${clients.cnpj}`}
                                onChange={(e, value) => setClientId(value ? value.id : '')}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                sx={{
                                    width: '100%',
                                    backgroundColor: "white",
                                    borderRadius: "10px",
                                    '& .MuiInputBase-root': {
                                        height: '40px', // ou o valor desejado
                                        fontSize: '14px', // ou o valor desejado                                      
                                    }
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridClients">
                            <Form.Label>Natureza</Form.Label>
                            <Form.Control onChange={event => setNature(event.target.value)} as="select" defaultValue="Choose...">
                                {natures.map((nature, index) => (
                                    <option key={String(index)} value={nature}>{nature}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridSellsman">
                            <Form.Label>Pagamento</Form.Label>
                            <Form.Control onChange={(event) => setPayment(event.target.value)} as="select" value={payment}>
                                {payments.map(pay => (
                                    <option key={pay.id} value={pay.description}>{pay.description}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAmount">
                            <Form.Label>Observação</Form.Label>
                            <Form.Control onChange={event => setObservation(event.target.value)} type="text" placeholder="Observação" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridProduct">
                            <Form.Label>Produtos</Form.Label>
                            <Form.Control onChange={event => setProductId(event.target.value)} as="select" defaultValue="Choose...">
                                {products.map((product, index) => (
                                    <option key={String(index)} value={product.id}>{product.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAmount">
                            <Form.Label>Quantidade</Form.Label>
                            <Form.Control onChange={event => setAmount(event.target.value)} type="double" placeholder="Quantidade de produtos" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPrice">
                            <Form.Label>Preço do produto</Form.Label>
                            <MaskReal value={price} onChange={value => setPrice(value.replace(',', '.'))} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridDiscount">
                            <Form.Label>Desconto</Form.Label>
                            <MaskReal onChange={value => setDiscount(value.replace(',', '.'))} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridDate">
                            <Form.Label>Data</Form.Label>
                            <div>
                                <DatePicker
                                    selected={startDate}
                                    onChange={date => setStartDate(date.withoutTime())}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Digite ou clique aqui"
                                    disabledKeyboardNavigation />
                            </div>
                        </Form.Group>
                    </Form.Row>
                    <div className="d-flex justify-content-center">
                        <Button color="success" onClick={(e) => (addToList(e))}>
                            Adicionar a lista
                        </Button>
                        <Button color="success" onClick={cleanList}>
                            Limpar a lista
                        </Button>
                    </div>
                    {<Form.Row>
                        <Table
                            tableHeaderColor="danger"
                            tableHead={["Quantidade", "Produto", "Preço", "Desconto", "Vendedor", "Ações"]}
                            tableData={tableData()}
                        />
                        <div className={classes.margintp}>
                            <b>Preço total: R${totalList}<br />
                                Total de descontos: R$ {totalDiscount} <br />
                                Resultado da operação: R$ {parseFloat(totalList - totalDiscount).toFixed(2)}</b>
                        </div>
                    </Form.Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" onClick={(e) => addOrder(e)}>
                            Concluir
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message={" lote adicionado com sucesso"}
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                    {loading ?
                        <div>
                            <SomeSpinner />
                        </div> :
                        <div></div>
                    }
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddOrderSellsman;